import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router/composables';
import ProblemsPopup from './ProblemsPopup.vue';
import DatePicker from '@/components/DatePicker.vue';
import { ProblemShipmentsApi, ProblemShipmentModel } from '@/openapi';
import { serialize } from 'object-to-formdata';
import axios, { AxiosResponse } from 'axios';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  __name: 'Problems',
  setup(__props) {

const route = useRoute();
const api = new ProblemShipmentsApi(undefined, '');
const mrn = ref('');
const mawb = ref('');
const fromDateModel = ref(
    moment()
        .subtract(3, 'months')
        .format('yyyy-MM-DD')
);
const tillDateModel = ref(moment().format('yyyy-MM-DD'));
const maxDate = moment().format('yyyy-MM-DD');
const loading = ref(false);
const isPopupOpen = ref(false);
const selectedShipment = ref<ProblemShipmentModel>({
    id: 0,
    customsHandlingMilestoneId: 0,
    customsHandlingBlockingMilestoneId: 0,
    milestoneCustomsHandlingId: 0,
    customsHandlingBlockingMilestoneRemarkId: 0,
    hawb: '',
    mawb: '',
    pieces: 0,
    value: 0,
    valueCurrency: '',
    weight: 0,
    shipperName: '',
    shipperAddress: '',
    shipperAddAddr: '',
    shipperZipcode: '',
    shipperCity: '',
    shipperCountry: '',
    invoiceName: '',
    invoiceAddress: '',
    invoiceAddAddr: '',
    invoiceZipcode: '',
    invoiceCity: '',
    invoiceCountry: '',
    eoriNumber: '',
    niederlassungsnummer: '',
    blockingMilestone: '',
    milestoneDatetime: '',
    receiverName: '',
    incoterm: '',
    lastRemark: '',
    remark: '',
    category: '',
});
const categoryShipments = ref<ProblemShipmentModel[]>([]);

const headers = ref([
    { text: 'HAWB', value: 'hawb' },
    { text: 'MAWB', value: 'mawb' },
    { text: 'Blocking Milestone', value: 'blockingMilestone' },
    { text: 'Milestone Datetime', value: 'milestoneDatetime' },
    { text: 'Receiver Name', value: 'receiverName' },
    { text: 'Incoterm', value: 'incoterm' },
    { text: 'Category', value: 'category', align: 'right' },
    { text: 'Last Remark', value: 'lastRemark' },
    { text: 'Actions', value: 'actions', sortable: false },
]);

const shipments = ref<ProblemShipmentModel[]>([]);

const documentRequiredCount = computed(
    () =>
        shipments.value.filter((s) => s.category === 'Document Required').length
);
const informationRequiredCount = computed(
    () =>
        shipments.value.filter((s) => s.category === 'Information Required')
            .length
);

const formFilled = computed(() => {
    return (
        mrn.value || mawb.value || (fromDateModel.value && tillDateModel.value)
    );
});

const footerProps = ref({
    'items-per-page-options': [50, 100, 250],
});

const openShipmentPopup = (shipment: ProblemShipmentModel) => {
    selectedShipment.value = { ...shipment };
    categoryShipments.value = [shipment];
    isPopupOpen.value = true;
};

const viewCategoryShipments = (category: string) => {
    categoryShipments.value = shipments.value.filter(
        (s) => s.category === category
    );
    if (categoryShipments.value.length > 0) {
        selectedShipment.value = categoryShipments.value[0]; // Pick first shipment of the category
        isPopupOpen.value = true;
    }
};

const formatMilestoneDateTime = (item: ProblemShipmentModel) => {
    return moment(item.milestoneDatetime).format('yyyy-MM-DD HH:mm:ss');
};

const closePopup = () => {
    isPopupOpen.value = false;
};

function getItems() {
    loading.value = true;
    api.getProblemShipments(
        mawb.value,
        mrn.value,
        fromDateModel.value,
        tillDateModel.value
    )
        .then((res) => {
            shipments.value = res.data;
        })
        .finally(() => {
            loading.value = false;
        });
}

async function save(shipemnt: ProblemShipmentModel) {
    loading.value = true;
    const formData = serialize(shipemnt);
    formData.getAll('documents[]').forEach((document) => {
        formData.append('documents', document);
    });
    formData.delete('documents[]');
    await axios
        .post<any, AxiosResponse<ProblemShipmentModel>>(
            '/api/ProblemShipments/SaveProblemShipments',
            formData
        )
        .then(() => {
            getItems();
        })
        .finally(() => {
            loading.value = false;
            let index = categoryShipments.value.findIndex(
                (s) => s.id === shipemnt.id
            );
            categoryShipments.value.splice(index, 1);
            if (categoryShipments.value.length === 0) {
                closePopup();
            }
        });
}

function checkQueryString() {
    if (route.query.mawb) {
        mawb.value = route.query.mawb as string;
    } else if (route.query.mrn) {
        mrn.value = route.query.mrn as string;
    }
}

onMounted(() => {
    checkQueryString();
    getItems();
});

return { __sfc: true,route, api, mrn, mawb, fromDateModel, tillDateModel, maxDate, loading, isPopupOpen, selectedShipment, categoryShipments, headers, shipments, documentRequiredCount, informationRequiredCount, formFilled, footerProps, openShipmentPopup, viewCategoryShipments, formatMilestoneDateTime, closePopup, getItems, save, checkQueryString, ProblemsPopup, DatePicker }
}

})